import { INVENTORY_QUERY_FRAGMENT } from '../../../../common/inventory/services/InventoryService';
import { BaseGQLService } from '../../../../common/services/BaseGQLService';
import { ModelType } from '../../../../common/utils/GQLIdEncoder';
import { ProjectExportOptions } from '../../../options/ProjectExportOptions';
import { ProjectCsvMapper } from '../mappers/ProjectCsvMapper';
import { ProjectCsvData } from '../models/ProjectCsvData';

export const GET_PROJECT_CSV_QUERY = `
query ($projectId: ID!, $withExceptions: Boolean!) {
  project: node(id: $projectId) {
    ... on Project {
      vulnerabilities(withExceptions: $withExceptions) {
        edges {
          node {
            number
            title
            shortExplanation
            severity
            numberOfSlots
          }
        }
      }
      inventory {
        ${INVENTORY_QUERY_FRAGMENT}
      }
    }
  }
}
`;

export class ProjectCsvRepository extends BaseGQLService {
  private readonly mapper = new ProjectCsvMapper();

  protected addTypename(): boolean {
    return false;
  }

  async getProject(projectId: number, options: ProjectExportOptions): Promise<ProjectCsvData> {
    const { withExceptions = false } = options;
    return this.query(
      GET_PROJECT_CSV_QUERY,
      {
        projectId: this.gqlIdEncoder.encode(ModelType.Project, projectId),
        withExceptions,
      },
      (data) => this.mapper.mapGQLModel(data.project)
    );
  }
}
